module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vbl-popover",
    class: _vm.place,
    on: {
      "mouseenter": _vm.onMouseenter,
      "mouseleave": _vm.onMouseleave
    }
  }, [_c('div', {
    ref: "trigger"
  }, [_vm._t("default")], 2), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "content",
    staticClass: "popover-content",
    style: (_vm.position)
  }, [_c('div', {
    staticClass: "arrow"
  }), _c('div', {
    staticClass: "popover-main"
  }, [_vm._t("content")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aea51bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblPopover/src/vblPopover.vue
// module id = 275
// module chunks = 0